import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import Header from 'components/header/Header';
import Footer from 'components/footer/Footer';
import Content from 'components/Content';
import RequiresAuth from 'components/auth/RequiresAuth';
import { Link } from 'react-router-dom';
import { asyncFetchBundle } from 'actions/bundles';
import './PurchasedBundle.scss';

import AssetThumbnail from 'components/common/AssetThumbnail';

export class PurchasedBundle extends Component {
  state = { preview: null };

  componentDidMount() {
    const { id } = this.props.match.params;
    const { fetchBundle } = this.props;
    fetchBundle(id);
    const { bundle } = this.props;
    if (bundle) {
      document.title = `Doodly: ${bundle.name} SVG doodle images`;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    ReactTooltip.rebuild();
  }

  previewAsset = asset => {
    this.setState({
      preview: asset.rainbow_path || asset.path
    });
  };

  render() {
    const { bundle, categories } = this.props;
    const { preview } = this.state;
    const category = bundle ? categories.find(c => c.id === parseInt(bundle.categ_id)) : null;

    return (
      <div className="purchased bundle d-flex flex-column">
        <RequiresAuth />
        <Header />
        <Content>
          {category && (
            <div className="breadcrumbs">
              <Link to="/">Home</Link>
              <span className="sep">&gt;</span>
              {category && (
                <>
                  <Link to={`/category/${category.name}`}>{category.name}</Link>
                  <span className="sep">&gt;</span>
                </>
              )}
              {bundle.name}
            </div>
          )}
          <div className="sheet">
            {bundle ? (
              <div className="row">
                <div className="col-md-6 thumbnails">
                  <AssetThumbnail
                    className="large thumb"
                    image={preview || bundle.thumb_path}
                    style={{ backgroundSize: preview ? 'contain' : 'cover' }}
                  />
                  <div className="d-flex justify-content-between flex-wrap">
                    {bundle.assets &&
                      bundle.assets.map((asset, i) => (
                        <AssetThumbnail
                          className="small thumb"
                          image={asset.rainbow_path || asset.path}
                          key={i}
                          onClick={this.previewAsset.bind(this, asset)}
                          title={asset.title}
                        />
                      ))}
                    <div className="small thumb clear"></div>
                    <div className="small thumb clear"></div>
                    <div className="small thumb clear"></div>
                    <div className="small thumb clear"></div>
                    <div className="small thumb clear"></div>
                  </div>
                </div>
                <div className="col-md-6 details">
                  <h2>{bundle ? bundle.name : 'Loading...'}</h2>
                  {/* <div className="d-flex align-items-center buy">
                    <a href={`${apiUrl}/bundles/${bundle.id}/download`} className="btn btn-primary">
                      Download bundle
                    </a>
                  </div> */}
                  <div className="description">
                    {bundle.description.split('\n').map((line, i) => (
                      <p key={i}>{line}</p>
                    ))}
                  </div>
                  <div className="notice">Click a thumbnail image to the left to see a preview.</div>
                </div>
              </div>
            ) : (
              <i className="loading fas fa-spinner fa-spin" />
            )}
          </div>
        </Content>
        <Footer />
        <ReactTooltip effect="solid" />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { bundles, categories } = state;
  return {
    bundle: bundles.currentBundle,
    categories
  };
};

const mapDispatchToProps = dispatch => ({
  fetchBundle: bundleId => dispatch(asyncFetchBundle(bundleId))
});

export default connect(mapStateToProps, mapDispatchToProps)(PurchasedBundle);
